/**
 * @generated SignedSource<<6cbc9e37ad2bac6a887cb38e741be8fc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigator_refetchQueryNew$data = {
  readonly jira: {
    readonly issueSearchViewResult: {
      readonly __typename: "JiraIssueSearchView";
      readonly " $fragmentSpreads": FragmentRefs<"issueSearch_issueNavigator" | "main_issueNavigator_IssueNavigatorUI_viewResult" | "selectedView_issueNavigator_SelectedViewContainer">;
    } | null | undefined;
    readonly jiraIssueSearchView?: {
      readonly __typename: "JiraGroupedListView";
      readonly groups: {
        readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_groupResults">;
      } | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_issueSearchData">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigator_refetchQueryNew";
};
export type main_issueNavigator_IssueNavigator_refetchQueryNew$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigator_refetchQueryNew$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_refetchQueryNew">;
};

import IssueNavigatorIssueSearchRefetchQuery_graphql from './IssueNavigatorIssueSearchRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "filterId",
    "variableName": "filterId"
  },
  {
    "kind": "Variable",
    "name": "namespace",
    "variableName": "namespace"
  },
  {
    "kind": "Variable",
    "name": "viewId",
    "variableName": "viewId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "amountOfColumns"
    },
    {
      "kind": "RootArgument",
      "name": "before"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetIds"
    },
    {
      "kind": "RootArgument",
      "name": "filterId"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "issueTypeId"
    },
    {
      "kind": "RootArgument",
      "name": "last"
    },
    {
      "kind": "RootArgument",
      "name": "namespace"
    },
    {
      "kind": "RootArgument",
      "name": "options"
    },
    {
      "kind": "RootArgument",
      "name": "projectId"
    },
    {
      "kind": "RootArgument",
      "name": "shouldQueryFieldSetsById"
    },
    {
      "kind": "RootArgument",
      "name": "viewId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": IssueNavigatorIssueSearchRefetchQuery_graphql
    }
  },
  "name": "main_issueNavigator_IssueNavigator_refetchQueryNew",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueNavigator_issueSearchData"
    },
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v0/*: any*/),
              "kind": "LinkedField",
              "name": "jiraIssueSearchView",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "after",
                          "variableName": "after"
                        },
                        {
                          "kind": "Variable",
                          "name": "before",
                          "variableName": "before"
                        },
                        {
                          "kind": "Variable",
                          "name": "first",
                          "variableName": "first"
                        },
                        {
                          "kind": "Variable",
                          "name": "issueSearchInput",
                          "variableName": "issueSearchInput"
                        },
                        {
                          "kind": "Variable",
                          "name": "last",
                          "variableName": "last"
                        }
                      ],
                      "concreteType": "JiraSpreadsheetGroupConnection",
                      "kind": "LinkedField",
                      "name": "groups",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "main_issueNavigator_IssueNavigatorUI_groupResults"
                        }
                      ]
                    }
                  ],
                  "type": "JiraGroupedListView"
                }
              ]
            }
          ]
        },
        {
          "args": (v0/*: any*/),
          "kind": "LinkedField",
          "name": "issueSearchViewResult",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "FragmentSpread",
                  "name": "issueSearch_issueNavigator"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "selectedView_issueNavigator_SelectedViewContainer"
                }
              ],
              "type": "JiraIssueSearchView"
            },
            {
              "kind": "FragmentSpread",
              "name": "main_issueNavigator_IssueNavigatorUI_viewResult"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "2aee6ffee833a992558848a64197eb85";

export default node;
